import BlessingsDetail from "./BlessingsDetail";

export default BlessingsDetail;
export { BlessingsDetail };
